<div class="d-flex gap-3">
  <div class="container-box shadow-none flex-fill">
    <div class="d-flex gap-3 align-items-center p-3">
      <img src="/assets/images/channel-wizards/step-icon1.webp" alt="" height="40" />
      <div>
        <h6 class="mb-0" i18n>Preparation</h6>
        <div class="text-sm">
          <ng-container i18n>This section will prepare you for connecting Airbnb with AdvanceCM.</ng-container> <br />
          <ng-container i18n>Please read through these instructions carefully before proceeding.</ng-container>
        </div>
      </div>
    </div>
    <div class="border-top p-4">
      <div>
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n> Outside Pricing Tools </mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>
              Though you are unable to retain control of Airbnb’s pricing tools when connected via the official API,
              connections between Airbnb and outside pricing tools like PriceLabs or BeyondPricing will not be affected.
              You can continue pushing rates from these websites directly to Airbnb as long as you choose not to
              overwrite those prices by pushing rates manually from AdvanceCM.
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n> Passing the Airbnb Review step </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <p i18n>
                Before proceeding with the connection wizard it is recommended that you ensure your listing will pass
                Airbnb’s review process.
              </p>

              <ng-container i18n>The guidelines for this are as follows:</ng-container>
              <ul>
                <li i18n>A minimum of 7 photos (3 of them being high quality)</li>
                <li i18n>A listing Title that does not exceed 50 characters in length</li>
                <li i18n>A listing Summary(Description) that is a minimum of 50 characters but no more than 500.</li>
              </ul>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n> Importing or Creating AdvanceCM Rentals </mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>
              The official Airbnb API allows you to import your properties which saves you the step of creating these
              rentals in AdvanceCM. One of the benefits of doing so is that Airbnb photos and the rental description
              will be imported with the property. If you have already created rentals and choose not to import them from
              Airbnb you will be able to simply link the already existing AdvanceCM rentals to your Airbnb listing(s) as
              needed.
            </p>
            <p>
              <ng-container i18n
                >If you would like to delete the listings you have created in order to take advantage of this Import
                function please see</ng-container
              >
              <a href="http://help.tokeet.com/rental-settings/how-do-i-delete-a-rental" target="_blank" i18n
                >the guide</a
              >
              <ng-container i18n>for deleting AdvanceCM rentals.</ng-container>
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n> Connecting Co-host Listings </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <p i18n>
                If any of the listings you wish to connect with AdvanceCM are co-host listings there are some important
                items to note before proceeding.
              </p>
              <ul>
                <li i18n>Co-host connections are not officially supported via the Airbnb API.</li>
                <li i18n>
                  A process must be followed after connection to ensure that availability is pushed and messaging from
                  AdvanceCM to the guest via Airbnb works properly.
                </li>
                <li i18n>
                  Rates cannot be pushed from AdvanceCM to Airbnb on co-host listings. Your rate tools on Airbnb will
                  still be accessible after using the co-host workaround steps offered later in this guide.
                </li>
                <li i18n>
                  Multiple Airbnb accounts that share the same listing via the co-host function in Airbnb cannot be
                  connected to AdvanceCM at the same time. In order to connect both accounts, one account must remove
                  the co-host before a connection can be established with both accounts.
                </li>
              </ul>
              <ng-container i18n>Please see</ng-container>
              <a
                href="https://help.tokeet.com/channel-manager/airbnb/co-hosting-with-airbnb-api-new"
                target="_blank"
                i18n
                >the guide</a
              >
              <ng-container i18n
                >for information on how to address these listings once you have completed the connection on all other
                listings.</ng-container
              >
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div
        class="alert alert-danger d-flex align-items-center justify-content-between gap-3 mt-4 mb-0"
        *ngIf="errorMessage"
      >
        <div>
          <i class="fas fa-exclamation-circle"></i>
          {{ errorMessage }}
        </div>
        <button class="btn btn-sm btn-outline-danger flex-shrink-0" (click)="authorize.emit()" i18n>Retry</button>
      </div>
      <div class="mt-5 d-flex align-items-center justify-content-between">
        <button class="btn btn-outline-light" (click)="prev.emit()">
          <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
          <ng-container i18n>Previous</ng-container>
        </button>
        <button class="btn btn-secondary-info" (click)="authorize.emit()">
          <ng-container i18n>Connect</ng-container>
          <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/step2.webp" alt="" class="w-100" />
  </div>
</div>
